<template>
    <div class="relative UiArticleMediaImage">
      <NuxtImg  
               :src="toImgixPath(src)"
               provider="imgix" 
               format="webp"
               :width="width"
               :fetchpriority="fetchpriority"
               :height="height"
               :loading="lazyload"
               :fit="fit" 
               :sizes="sizes" 
               :modifiers="modifiers" 
               :alt="altText" 
               class="w-full" />
      <!-- Overlay med gradient från svart till transparent -->
      <div v-if="overlaytop" class="absolute inset-0 overlaytop"></div>
      <div v-if="overlaybottom" class="absolute inset-0 overlaybottom"></div>
    </div>
  </template>
  
  
  
  
  <script setup>
  import { IconAlertTriangle } from '@tabler/icons-vue';
import { computed } from 'vue';
  const {toImgixPath} = useImageUtils();
  
  // Props
  const props = defineProps({
    src: {
      type: String,
      required: true
    },
    
    fetchpriority: {
      type: String,
      default: 'high' // eller undefined
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    width: {
    type: Number,
      default: 375
    },
    height: {
      type: Number,
      default: 300
    },
    modifiers: {
      type: Object,
      default: () => ({
        auto: 'format,compress',
        fit: 'crop',
        crop: 'faces,edges'
      })
    },
    fit:{
      type: String,
      default: 'crop'
    },
    sizes: {
      type: String,
      default: 'sm:309px md:700px lg:700px xl:1335px'
    },
    lazy: {
      type: Boolean,
      default: false
    },
    overlaytop: {
      type: Boolean,
      default: false
    },
    overlaybottom: {
      type: Boolean,
      default: false
    },
    altText: {
      type: String,
      default: ''
    },

    
  
  });
  
  const lazyload = computed(() => {
    return props.lazy ? 'lazy' : 'eager';
  });
  
  
  
  </script>

  <style scoped>
    .overlaytop {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0) 68.33%, rgba(0, 0, 0, 0.42) 84.17%);
    }
    .overlaybottom {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 59.29%, rgba(0, 0, 0, 0.62) 81.68%);
    }

    /* Rectangle 8 */


       
  </style>